import React, { useContext } from "react";
import CertificationSessionContext from "module/certificationSession/context/CertificationSessionContext";
import { CertificationSessionInterface } from "module/certification/types";
import CertificationSessionTableRowCategory from "./CertificationSessionTableRowCategory";

const CertificationSessionTableRowCategoryContainer: React.FC = () => {
  const { entity } = useContext(CertificationSessionContext);

  const certificationSession = entity as CertificationSessionInterface;
  const { name, level } = certificationSession;

  return <CertificationSessionTableRowCategory {...{ name, level }} />;
};

export default React.memo(CertificationSessionTableRowCategoryContainer);
